import React from 'react';
import styled from 'styled-components';
import Location from '../../assets/target.png';
import ReusableDetailCard from '../../components/ReusableDetailCard/ReusableDetailCard';
import Urchins from '../../components/Urchins/Urchins';

const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  border: none;
  border-radius: 9px;
  justify-content: space-around;
  background-color: rgba(0,0,0,0.5);
  backdrop-filter: blur(3px);  
  overflow:hidden;
  box-shadow: 1px 0px 7px rgba(0, 0, 0, 0.5);
  

`;

const Viz = styled.div`
  display: flex;
  width:100%;
  height:50vh;
  justify-content: flex-start;
  align-self:stretch;
  overflow:hidden;
  border-radius: 9px;
  border:none;
  background-color: rgba(0,0,0,0.5);
  position: relative;

  
`;

class CardUrchins extends React.Component {
  render () {
   return (

  <Container>
    <Viz>
    
      <Urchins/>       
    
      
            
    </Viz>

      <ReusableDetailCard
   trend= {Location}
   metricsm="Prevalent Worldwide"
   diagnosis="Urchins on the seafloor, including purple sea urchins, are important prey for sea otters and sea stars. Sea urchin grazing is slowly but steadily decimating kelp forests on the U.S. Pacific Coast."
   prediction="Declining natural predators and food sources (kelp) are leading to overpopulation, which threatens the stability of these ecosystems (Oceana)."
   significanceorthreat="THREAT"
   confidence="CONFICENCE LV: 95%"
   />
  </Container>
  );
 }
}

export default CardUrchins;
